import './productionpartner.scss';

class Prodcutionpartner {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-productionpartner',
            tabsAttr: 'tab',
            labelAttr: 'label'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$productionPartner = element;
        this.$tabNavigationTabs = this.$productionPartner.querySelectorAll(`[${this.settings.initAttr}="${this.settings.tabsAttr}"]`);
        this.$tabNavigationLabels = this.$productionPartner.querySelectorAll(`[${this.settings.initAttr}="${this.settings.labelAttr}"]`);
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        for (let a = 0; a < this.$tabNavigationTabs.length; a++) {
            const $tab = this.$tabNavigationTabs[a];

            $tab.addEventListener('click', (e) => {
                this.removeActiveState();
                this.setActiveTab(e.target.getAttribute('id'));
            });
        }
    }

    setActiveTab (activeId) {
        const $activeLabel = this.$productionPartner.querySelector('label[for="' + activeId + '"]');
        $activeLabel.classList.add('is--active');
    }

    removeActiveState () {
        for (let i = 0; i < this.$tabNavigationLabels.length; i++) {
            const $tab = this.$tabNavigationLabels[i];
            $tab.classList.remove('is--active');
        }
    }
}

export { Prodcutionpartner };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$productionPartners = $context.querySelectorAll('[data-productionpartner="root"]');

        for (let i = 0; i < $$productionPartners.length; i++) {
            const $productionPartner = new Prodcutionpartner($$productionPartners[i]);
            $productionPartner.initialize();
        }
    }
});
